import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography,  TextField,} from '@mui/material';
import { i18n } from '../../../translate/i18n';
import { RootState } from '../../../store/types';
import signatureIcon from '../../../assets/signature-icon.svg';

type Props = {
  // setName: CallableFunction,
  // setDocument: CallableFunction,
  isNewData: boolean,
  editMode: boolean,
};

const Signature: React.FC<Props> = ({ /* setName, setDocument, */ isNewData, editMode }) => {

  const signatures = useSelector((state: RootState) => state.editService.selectedService.signatures);
  const signature = useSelector((state: RootState) => state.editService.selectedService.signature);

  const signaturesToShow = signatures && signatures.length > 0 ? signatures : (signature?.file && signature.file.url !== '') ? [signature] : [];

  return <>
    <Box sx={{...styles.signatureContainer, color: (!isNewData && !editMode) ? 'lightgrey' : '#6F8189',}}>
      <Box sx={styles.sectionTitleContainer}>
        <img src={signatureIcon} style={{ width: '24px', height: '24px'}} />
        <Typography sx={{marginRight: '10px', marginLeft: '5px'}}>
          {i18n.t('typographyFormService.signatures') as string}
        </Typography>
      </Box>
    </Box>
    { signaturesToShow && signaturesToShow.length > 0 &&
      <Box>
        {signaturesToShow.map((signature, index) => {
          const isSignatureFromWeb = signature?.file.source === 'web';
          const complement = signature.complement || signature.document;
          return <Box key={index} sx={{padding: '16px', backgroundColor: '#F3F3F3', borderRadius: '8px', width: '100%', marginBottom: '10px', display: 'inline-flex', gap: '16px', flexDirection: 'column', marginTop: '12px' }}>
            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
              <Box>
                <Typography sx={{fontSize: 12, color: 'rgba(0, 0, 0, 0.6)', marginBottom: '5px'}}>{i18n.t('typographyFormService.signature') as string}</Typography>
                <img src={signature.file.url!} style={isSignatureFromWeb ? styles.signatureImage : styles.signatureApp} />
              </Box>
            </Box>
            <TextField
              variant="standard"
              label={i18n.t('textFieldFormService.accountable') as string}
              name={'signature-name' + index}
              value={(signature.name && signature.name !== '') ? signature.name : '-' }
              margin='none'
              disabled={true}
              sx={{
                width: '40%',
                marginTop: '10px',
                marginBottom: '10px',
              }}
            />
            <TextField
              variant="standard"
              label={i18n.t('typographyFormService.complement') as string }
              name={'signature-complement' + index}
              value={(complement && complement !== '') ? complement : '-'}
              margin='none'
              disabled={true}
              sx={{
                width: '40%',
                marginTop: '10px',
                marginBottom: '10px',
              }}
            />
          </Box>
        })}
      </Box>
    }
  </>
}

const styles = {
  signatureContainer: {
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    marginTop: '20px'
  },
  sectionTitleContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  formControl: {
    display: 'flex',
  },
  signatureLabel: {
    marginTop: '12px',
    marginRight: '10px',
    color: 'rgba(0, 0, 0, 0.38)',
    fontSize: '0.8rem',
  },
  textField: {
    width: '40%',
    marginTop: '10px',
    marginBottom: '10px',
  },
  signatureImage: {
    marginBottom: '10px',
    width: "190px",
    height: '60px',
    backgroundColor: 'white',
  },
  signatureApp: {
    width: "60px",
    height: "190px",
    borderRadius: "5px",
    objectFit: "contain" as "contain",
    transform: "rotate(-90deg)",
    margin: "-60px 0 -70px 65px",
    backgroundColor: "white",
  },
}

export default Signature;